import React from 'react';
import c from 'classnames';
import s from './Description.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const Description: React.FC<Props> = ({ children, className }) => (
  <p className={c(s['root'], className)}>{children}</p>
);

Description.displayName = 'Description';

export default Description;
